import React, { useState, useEffect, useCallback } from "react";
import { Layout } from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import axios from "axios";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const SensorAlerts = () => {
  let navigate = useNavigate();
  const { Content } = Layout;

  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const SensorApi = localStorage.getItem("SensorApi");

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const [Alerts, setAlerts] = React.useState([]);

  const getRuntimeConfigs = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {

        let url = `https://api.sync-sign.com/v2/oauth/token`;

        axios
          .post(url, {
            "username": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'USER_NAME')[0]?.configValue),
            "password": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'PASSWORD')[0]?.configValue),
            "provider": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'PROVIDER')[0]?.configValue)

          })
          .then((res) => {
            localStorage.setItem("SensorApi", res?.data?.data?.accessToken);
            let headers = {
              Authorization: `Bearer ${res?.data?.data?.accessToken}`,
              "accept": `application/json`,
            };
            let url2 = `https://api.sync-sign.com/v2/alerts?limit=100`;
            axios
              .get(url2, {
                headers: headers,
              })
              .then((res2) => {
                setIsLoading(false);
                setAlerts(res2?.data?.data)
              })
              .catch((err) => {
                console.log(err);

              });
          })
          .catch((err) => {
            console.log(err);

          });
    setTotalElements(response.totalElements);
    setTotalPages(response.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getStorageInstruction = useCallback(async () => {
    if (!SensorApi) {
      setIsLoading(true);
      getRuntimeConfigs();
    } else {
      let headers = {
        Authorization: `Bearer ${SensorApi}`,
        "accept": `application/json`,
      };
      let url2 = `https://api.sync-sign.com/v2/alerts?limit=100`;
      axios
        .get(url2, {
          headers: headers,
        })
        .then((res2) => {
          console.log(res2?.data)
          setIsLoading(false);
          setAlerts(res2?.data?.data)
        })
        .catch((err) => {
          console.log(err);

        });
    }

  }, []);

  useEffect(() => {
    getStorageInstruction();
    PageLoading();
  }, [getStorageInstruction, PageLoading]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const handleGoBack = () => {
    navigate(-1);
  };

  const paginatedData = Alerts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const convertUnixTimestampToTime = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000); // Multiply by 1000 to convert seconds to milliseconds
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}:${formattedMinutes} ${period}`;
  };
  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">

          <td style={{ width: "12%" }} className="pt-3">
            {convertUnixTimestampToTime(item?.time)}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.nodeId}
          </td>
          <td style={{ width: "10%" }} className="pt-3 ">
            {item?.type}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.info?.tm?.max} 'C
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {item?.info?.tm?.min} 'C
          </td>


        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
            />
            <br />
            {/* <Button
              className="btn btn-primary btn-save m-0 my-2 "
              onClick={handleOpenAddModal}
            >
              Add Stock
            </Button> */}
          </td>
        </tr>
      );
    }
  };


  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");


  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <Link
              className="btn btn-primary btn-back m-0 my-2 "
              onClick={handleGoBack}
            >
              Back
            </Link>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Node Id</th>
                  <th>Type</th>
                  <th>Max</th>
                  <th>Min</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={pageSize}
            />
          )}
          </div>
        </Content>



        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default SensorAlerts;
